export * from "@trpc/react-query/shared";

export const ENDPOINTS = [
  "loggedInViewerRouter",
  "admin",
  "apiKeys",
  "apps",
  "auth",
  "availability",
  "appBasecamp3",
  "bookings",
  "calendars",
  "customers",
  "calVideo",
  "credentials",
  "deploymentSetup",
  "eventTypes",
  "eventTypesHeavy",
  "features",
  "feedback",
  "holidays",
  "featureOptIn",
  "i18n",
  "me",
  "ooo",
  "payments",
  "public",
  "timezones",
  "slots",
  "travelSchedules",
  "users",
  "viewer",
  "webhook",
  "teams",
  "waitlist",
  "googleWorkspace",
  "oAuth",
  "delegationCredential",
  "credits",
  "filterSegments",
  "phoneNumber",
] as const;
